/**
 * ID-Erzeugung ohne `crypto.randomUUID` – das gibt es erst ab Safari 15.4,
 * das Ziel-iPad hat aber Safari 15.
 */
export function newId(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  let out = '';
  for (const byte of bytes) out += byte.toString(16).padStart(2, '0');
  return out;
}
